import { render, staticRenderFns } from "./copyHorizontal.vue?vue&type=template&id=d83c282a&"
import script from "./copyHorizontal.vue?vue&type=script&lang=ts&"
export * from "./copyHorizontal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports